import { APIAuth } from "../../utils/API"
import { emptyObject, hasProps, isEmpty } from "../../utils/Helper"

export async function getMBGSupplierDetail(id) {
    return APIAuth.get(`auth/supplier/detail/${id}`)
        .then((res) => res?.data?.data ?? undefined)
        .catch((err) => undefined)
}

export async function getMBGSupplierList(payload = {}) {
    const postData = new FormData()
    if (hasProps(payload, "page")) postData.append("limit", payload?.limit ?? 10)
    if (hasProps(payload, "page")) postData.append("page", payload?.page ?? 1)
    if (hasProps(payload, "q")) postData.append("q", JSON.stringify(payload?.q ?? {}))
    if (!isEmpty(payload?.exclude_id)) postData.append("exclude_id", JSON.stringify(payload?.exclude_id ?? []))
    if (!emptyObject(payload?.ob ?? {}) && hasProps(payload, "ob")) {
        postData.append("ob", JSON.stringify(payload?.ob ?? {}))
    }
    return APIAuth.post(`auth/supplier/list`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function createUpdateMBGSupplier(payload) {
    const addFlag = isEmpty(payload?.id)
    payload.telp = isEmpty(payload?.telp) ? "" : `0${payload?.telp?.replace(/^0+/, "")}`
    payload.warehouse_contact_person = payload.telp
    payload.region_id = payload?.region_id?.id ?? undefined
    payload.logo = payload?.logo?.img ?? null
    payload.account_bank_code = payload?.account_bank_code?.id ?? null

    delete payload?.channelList
    delete payload?.chainList
    delete payload?.regionList
    delete payload?.brandList

    // zip
    delete payload?.province
    delete payload?.sub_province
    delete payload?.district
    delete payload?.sub_district
    delete payload?.zip

    delete payload?.provinceList
    delete payload?.subProvinceList
    delete payload?.districtList
    delete payload?.subDistrictList

    const res = await (addFlag ? createMBGSupplier(payload) : updateMBGSupplier(payload.id, payload))
    return res
}

export async function deleteMBGSupplier(id) {
    return APIAuth.delete(`auth/supplier/${id}`)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

async function createMBGSupplier(payload) {
    delete payload.id
    const postData = Object.keys(payload).reduce((formData, key) => {
        if (!isEmpty(payload[key])) formData.append(key, payload[key])
        return formData
    }, new FormData())
    return APIAuth.post(`auth/supplier`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

async function updateMBGSupplier(id, payload) {
    delete payload.id
    const postData = Object.keys(payload).reduce((formData, key) => {
        if (!isEmpty(payload[key])) formData.append(key, payload[key])
        return formData
    }, new FormData())
    return APIAuth.post(`auth/supplier/${id}`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

// sku
export async function getSupplierSKUList(payload = {}) {
    const postData = new FormData()
    if (hasProps(payload, "supplier_id")) postData.append("supplier_id", payload?.supplier_id)
    if (hasProps(payload, "page")) postData.append("limit", payload?.limit ?? 10)
    if (hasProps(payload, "page")) postData.append("page", payload?.page ?? 1)
    if (hasProps(payload, "sku_name")) postData.append("sku_name", payload?.sku_name)
    return APIAuth.post(`group/project/item/list/master`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function getMBGSupplierSKUList(payload = {}) {
    const postData = new FormData()
    if (hasProps(payload, "supplier_id")) postData.append("supplier_id", payload?.supplier_id)
    if (hasProps(payload, "page")) postData.append("limit", payload?.limit ?? 10)
    if (hasProps(payload, "page")) postData.append("page", payload?.page ?? 1)
    if (hasProps(payload, "q")) postData.append("q", JSON.stringify(payload?.q ?? {}))
    if (hasProps(payload, "sku_name")) postData.append("sku_name", payload?.sku_name)
    if (!emptyObject(payload?.ob ?? {}) && hasProps(payload, "ob")) {
        postData.append("ob", JSON.stringify(payload?.ob ?? {}))
    }
    return APIAuth.post(`group/project/item/list/supplier`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function createUpdateSupplierSKU(payload) {
    [
        'brand', 'brand_id', 'unit_name', 'category_name', 'markup_price',
        'group_sku', 'created_at', 'created_by', 'link_image',
        'deleted_at', 'deleted_by',
        'updated_at', 'updated_by',
    ].map((key) => { delete payload[key] })
    const postData = Object.keys(payload).reduce((formData, key) => {
        let value = payload[key] ?? ""
        if (!isEmpty(value) || key === 'description') formData.append(key, value)
        return formData
    }, new FormData())
    return APIAuth.post(`group/project/item/supplier`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
    // return { code: 400, message: '' }
}

// bank account
export async function getBankCodeList(payload = {}) {
    const postData = new FormData()
    if (hasProps(payload, "page")) postData.append("limit", payload?.limit ?? 10)
    if (hasProps(payload, "page")) postData.append("page", payload?.page ?? 1)
    if (hasProps(payload, "name")) postData.append("name", payload?.name)
    return APIAuth.post(`group/dist/bank-code`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}

export async function getBankAccount(payload = {}) {
    const postData = new FormData()
    postData.append("account_number", payload?.account_number)
    postData.append("bank_destination", payload?.account_bank_code?.id)
    return APIAuth.post(`group/dist/inquiry-account`, postData)
        .then((res) => res.data)
        .catch((err) => err?.response ?? err?.data)
}